export const SERVER_TABLE_PAGE_SIZE_STORAGE_KEY = 'server-table-page-size';

export const SERVER_TABLE_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const VIRTUAL_PAGE_ITEM_HEIGHT = 36;
export const VIRTUAL_PAGE_VISIBLE_ITEM_COUNT = 7;
export const VIRTUAL_PAGE_OVERSCAN = 5;
